import { ClientSociety, SirenReturn } from "@dune/types";
import { defaultClientSocietyValues, defaultSocietyValues } from "@dune/vars";
import { UseFormSetValue } from "react-hook-form";
import { CreateConstructionSiteClientFormData } from "./../component/brokers/constructionSites/useCreateConstructionSiteForm";

export const formatClientSocietyForForm = (client: ClientSociety) => ({
	...client,
	isSyndic: client.syndicConstructionSites?.length > 0,
	streetNumber: client.headOfficeAddress?.streetNumber ?? "",
	streetName: client.headOfficeAddress?.streetName ?? "",
	postalCode: client.headOfficeAddress?.postalCode ?? "",
	city: client.headOfficeAddress?.city ?? "",
	hasUserAccess: client.syndicUserAccessToPlatform ? "true" : "false",
	userAccess: client.syndicUserAccessToPlatform
		? {
				firstname: client.syndicUserAccessToPlatform.firstname,
				lastname: client.syndicUserAccessToPlatform.lastname,
				email: client.syndicUserAccessToPlatform.email ?? "",
			}
		: undefined,
	hasBrokerageFees: client.brokerageFees ? "true" : "false",
	brokerageFees: client.brokerageFees?.toString() ?? undefined,
});

export const updateFormSirenSociety = (
	isSuccess: boolean,
	sirenValue: string,
	sirenSociety: SirenReturn | undefined,
	// biome-ignore lint/suspicious/noExplicitAny: setValue are from different forms
	setValue: UseFormSetValue<any>,
	formKey: string,
	isSyndicForm = false,
) => {
	if (isSuccess && sirenSociety) {
		if ("id" in sirenSociety) {
			setValue(formKey, formatClientSocietyForForm(sirenSociety));
		} else {
			const { denomination, headOfficeAddress } = sirenSociety;
			const { streetNumber, streetName, postalCode, city } =
				headOfficeAddress || {};
			setValue(`${formKey}.denomination`, denomination ?? "");
			setValue(`${formKey}.streetNumber`, streetNumber ?? "");
			setValue(`${formKey}.streetName`, streetName ?? "");
			setValue(`${formKey}.postalCode`, postalCode ?? "");
			setValue(`${formKey}.city`, city ?? "");
		}
	} else {
		setValue(formKey, {
			...defaultClientSocietyValues,
			isSyndic: isSyndicForm,
			siren: sirenValue,
		});
	}
};
export const updateFormSirenMOASociety = (
	isSuccess: boolean,
	sirenValue: string,
	sirenSociety: SirenReturn | undefined,
	setValue: UseFormSetValue<CreateConstructionSiteClientFormData>,
) => {
	if (isSuccess && sirenSociety) {
		if ("id" in sirenSociety) {
			setValue("moaClientSocietyId", sirenSociety.id);
		} else {
			setValue("moaClientSocietyId", undefined);
		}
		const { denomination, headOfficeAddress } = sirenSociety;
		const { streetNumber, streetName, postalCode, city } =
			headOfficeAddress || {};
		setValue("moaClientSociety.denomination", denomination ?? "");
		setValue("moaClientSociety.streetNumber", streetNumber ?? "");
		setValue("moaClientSociety.streetName", streetName ?? "");
		setValue("moaClientSociety.postalCode", postalCode ?? "");
		setValue("moaClientSociety.city", city ?? "");
	} else {
		setValue("moaClientSocietyId", undefined);
		setValue("moaClientSociety", {
			...defaultSocietyValues,
			siren: sirenValue,
		});
	}
};
